import { BROWSER_SESSION, BUILDER_SESSION } from '~/types'

export default () => {
  const route = useRoute()
  const router = useRouter()

  const browserSessionStore = useBrowserSessionStore()
  const { isAuthenticated: isBrowserSessionAuthenticated } = storeToRefs(browserSessionStore)

  const builderSessionStore = useBuilderSessionStore()
  const { isAuthenticated: isBuilderSessionAuthenticated } = storeToRefs(builderSessionStore)

  const { $posthog } = useNuxtApp()

  const backAction = () => {
    if (route.meta.auth === BROWSER_SESSION && isBrowserSessionAuthenticated.value) {
      browserSessionStore.cancelSession()
      $posthog.capture('browser_session_cancelled')
    }
    else if (route.meta.auth === BUILDER_SESSION && isBuilderSessionAuthenticated.value) {
      builderSessionStore.cancelSession()
      $posthog.capture('builder_session_cancelled')
    }
    else {
      router.back()
    }
  }

  return {
    backAction,
  }
}
